// Module
var code = "<td><a class=\"src-item\">{{srcShortName}}</a></td> <td>{{srcTable}}</td> <td class=\"withBorder\">{{srcCol}}</td> <td><a class=\"target-item\">{{targetShortName}}</a></td> <td>{{tarTable}}</td> <td>{{tarCol}}</td> <td class=\"error-message\" title=\"{{message}}\"><p>{{message}}</p></td> ";
// Exports
export default code;